import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  LiveTrackingKpi,
  LiveTrackingRecord,
} from "@/components/live-tracking/liveTrackingTypes";
import type { StaffMetricsResponse } from "@/actions/ssr/live-tracking/getStaffMetricsSSR";

interface LiveTrackingState {
  results: LiveTrackingRecord[];
  count: number;
  total_pages: number;
  current_page: number;
  kpi: LiveTrackingKpi;
}

const initialState: LiveTrackingState = {
  results: [],
  count: 0,
  total_pages: 0,
  current_page: 1,
  kpi: {
    activeStaffCount: 0,
    totalDistanceKm: "0",
    avgSessionMinutes: 0,
    pointsDropped: 0,
  },
};

const liveTrackingSlice = createSlice({
  name: "liveTracking",
  initialState,
  reducers: {
    setStaffMetrics(state, action: PayloadAction<StaffMetricsResponse>) {
      state.results = action.payload.results;
      state.count = action.payload.count;
      state.total_pages = action.payload.total_pages;
      state.current_page = action.payload.current_page;
      state.kpi = action.payload.kpi;
    },
  },
});

export const { setStaffMetrics } = liveTrackingSlice.actions;
export default liveTrackingSlice.reducer;
